import { createSlice } from "@reduxjs/toolkit";

interface AuthErrorState {
  hasAuthError: boolean;
}

const initialState: AuthErrorState = {
  hasAuthError: false,
};

const authErrorSlice = createSlice({
  name: "authError",
  initialState,
  reducers: {
    setAuthError: (state) => {
      state.hasAuthError = true;
    },
    clearAuthError: (state) => {
      state.hasAuthError = false;
    },
  },
});

export const { setAuthError, clearAuthError } = authErrorSlice.actions;

// Selectors
export const selectHasAuthError = (state: { authError: AuthErrorState }) => 
  state.authError.hasAuthError;

export default authErrorSlice.reducer;
